// What counts as a photo, what counts as a clip, and how big either may be.
// Pure: no Supabase, so the components that render media can import it without
// dragging the client along.

// .mov is what an iPhone hands over; the rest are what everything else does.
const VIDEO_EXTENSIONS = ['mov', 'mp4', 'm4v', 'webm', 'ogv', 'avi', 'mkv'];

export const ACCEPTED_MEDIA = 'image/*,video/*';

// Matches the bucket's own file_size_limit; Supabase rejects anything larger.
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;

export const extensionOf = (name) => {
  const match = /\.([a-z0-9]+)$/i.exec(String(name || ''));
  return match ? match[1].toLowerCase() : '';
};

export const isVideo = (path) => VIDEO_EXTENSIONS.includes(extensionOf(path));
